/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CrosshairSimple(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,28A100,100,0,1,0,228,128,100.113,100.113,0,0,0,128,28Zm8,183.60938V180a8,8,0,0,0-16,0v31.60938A84.13251,84.13251,0,0,1,44.39062,136H76a8,8,0,0,0,0-16H44.39062A84.13249,84.13249,0,0,1,120,44.39063V76a8,8,0,0,0,16,0V44.39063A84.13247,84.13247,0,0,1,211.60937,120H180a8,8,0,0,0,0,16h31.60937A84.13249,84.13249,0,0,1,136,211.60938Z" />
    </Svg>
  );
}

export default CrosshairSimple;
